// @flow
import createField from './createField';
import isBoolean from 'lodash/isBoolean';
import isNumber from 'lodash/isNumber';
import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';

/**
 * @type {FieldCreator}
 */
export const bool = createField('boolean', {
  validator: isBoolean,
});

/**
 * @type {FieldCreator}
 */
export const number = createField('number', {
  validator: isNumber,
});

/**
 * @type {FieldCreator}
 */
export const string = createField('string', {
  validator: isString,
});

/**
 * @type {FieldCreator}
 */
export const object = createField('object', {
  nested: true,
  validator: isPlainObject,
});

export const array = createField('array', {
  iterable: true,
  nested: true,
  validator: Array.isArray,
});
